// The form is shared between the customer app and the professional app, which
// build their API base and auth header differently. Each app injects its own
// once, at import time, rather than the form importing either app's helpers.

let deps = {
  getAPIUrl: (path) => path,
  getAuthToken: () => '',
  // The host's own mark: EG and WG ship different files, and the professional
  // app ships its own. The loader is the only thing that uses it.
  logoSrc: '',
  // The host's own name, EventGraphia or WedGraphia. The What to Expect
  // booklet is the only reader, and goes without it where none is given.
  brandName: '',
  // The onnxruntime wasm the face detector runs on, served by whichever app
  // is hosting the form. The detector itself comes down the API.
  ortWasmSrc: '',
  // Whether this is the build egadmin opens. Login as User signs in with the
  // couple's own token, so nothing in the request says ops is the one
  // reading; only the build does.
  isAdmin: () => false,
  // Where a reader whose sign in has lapsed is sent. Each app has its own
  // login page; without one the form says it could not load instead.
  goToLogin: null,
};

export const configureWeddingDay = (next) => {
  deps = { ...deps, ...next };
};

export const apiUrl = (path) => deps.getAPIUrl(path);
export const authHeader = () => deps.getAuthToken();
export const logoUrl = () => deps.logoSrc;
export const brandName = () => deps.brandName;
export const ortWasmPath = () => deps.ortWasmSrc;
export const isAdminBuild = () => !!deps.isAdmin && deps.isAdmin();
export const goToLogin = () => {
  if (!deps.goToLogin) return false;
  deps.goToLogin();
  return true;
};
